import { takeLatest } from 'redux-saga/effects';

import {
  ON_YOUR_ORDER_MOUNT,
  ON_YOUR_ORDER_ERROR,
  YOUR_ORDER_CANCEL_ORDER
} from '../actions';

import { fetchYourOrderData, cancelOrder } from './sagas';
import { redirectToHomepage } from '../../dashboard/actions/sagas';

// Watchers
export function* onYourOrderInit() {
  yield takeLatest(ON_YOUR_ORDER_MOUNT, fetchYourOrderData);
}

export function* onYourOrderRequestCancel() {
  yield takeLatest(YOUR_ORDER_CANCEL_ORDER, cancelOrder);
}

export function* redirectToHomepageOnYourOrderMountError() {
  yield takeLatest(ON_YOUR_ORDER_ERROR, redirectToHomepage);
}



// WEBPACK FOOTER //
// ./src/modules/your-order/actions/watchers.js